import Badge from './badge'

Badge.install = vue => vue.component(Badge.name, Badge)

export default Badge
